import { render, staticRenderFns } from "./LiveGamesList.vue?vue&type=template&id=1494558b&"
import script from "./LiveGamesList.vue?vue&type=script&lang=js&"
export * from "./LiveGamesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports